import { createFileRoute } from '@tanstack/react-router';
import { MenuTitle } from '../../../types';

export const Route = createFileRoute('/_private-routes/tiktok/subscription-billing')({
  staticData: {
    menuTitle: MenuTitle.Billing
  }
});
